import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";

export interface MarkMedicationAddedToChartCriteria {
  questionnaireResponseId: string;
  drugCode: string;
  drugCodeSystem: string;
}

export const useMarkMedicationAddedToChart = () => {
  return useApiMutation<void, MarkMedicationAddedToChartCriteria>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.Chart.AmazonVisitIntake
          .MARK_MEDICATION_ADDED_TO_CHART,
      mutationFn: async ({
        questionnaireResponseId,
        drugCode,
        drugCodeSystem,
      }: MarkMedicationAddedToChartCriteria) => {
        await axiosInstance.put(
          `amazon-clinic/medication-extractions/${questionnaireResponseId}/medication-added-to-chart`,
          {
            drugCode,
            drugCodeSystem,
          },
        );
      },
    },
  });
};
